import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/personaReferencia";
import {
  GetControversiaCurp,
  PutLiberarCurp
} from "../../../reducers/personaReferencia";

export interface ControversiaCurpDispatcher {
  getControversiaCurp: (
    idPersonaCurp: number,
    idPersonaSolicitante?: number
  ) => Promise<Preview<GetControversiaCurp>>;
  putLiberarCurp: (
    idPersona: number,
    idPersonaSolicitante?: number
  ) => Promise<Preview<PutLiberarCurp>>;
  clearPersonaReferencia: () => void;
}

export const controversiaCurpDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ControversiaCurpDispatcher = dispatch => ({
  getControversiaCurp: (idPersonaCurp: number, idPersonaSolicitante?: number) =>
    dispatch(actions.getControversiaCurp(idPersonaCurp, idPersonaSolicitante)),
  putLiberarCurp: (idPersona: number, idPersonaSolicitante?: number) =>
    dispatch(actions.putLiberarCurp(idPersona, idPersonaSolicitante)),
  clearPersonaReferencia: () => dispatch(actions.clearPersonaReferencia())
});
